export default function({ dispatch, commit }, verification) {
    commit('startedAuthentication')

    // POST /auth/verify/email
    return dispatch('post', {
        url: '/auth/verify/email',
        data: verification
    }, {
        root: true
    })
    .then((response) => {
        commit('finishedAuthentication')
        return response
    })
    .catch((error) => {
        commit('finishedAuthentication')
        throw error
    })
}
